import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import Modal from "react-bootstrap/Modal";
import axiosInstance from '../../config/axiosInstance';
import { ToastContainer, toast } from "react-toastify";
import { useLocation } from "react-router-dom";

import { formattedDateLong } from '../../utils/DateFormattings';
import { DateRangePicker } from '../../utils/ReusableFilters';
import { handleErrorToast, sortProjects, SkeletonLoader } from '../../utils/ReusableFunctions';
import { CircularGrid, SearchSmall, SubCompany, ExchangeTypee, Status } from '../../utils/ReusableSVGs';
import { LetterType, Projects } from '../../utils/ReusableFilters';

import { useParams } from 'react-router-dom';
import { BASE_URL } from './axios';
import Dashboardnavbar from '../../layout/Navbar/Navbar';
import usePermission from '../../config/Permissions';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import { AddLetterLinked, AssociatedLetters, CalculateDaysBetweenDates, CustomModel, DeleteTrackAndLetterDetails, UpdateTrackRecordDetails, DocumentModel, AddAssignTO } from './LetterComponents';
import AdvancedStats from './Advancedstats';
import StatusBar from './Statusbar';


const DashboardLetterTatTypeModel = ({ }) => {
    const [toggle, setToggle] = useState('toogle1');
    const [show, setShow] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [lettertatdata, setLettertatData] = useState([]);
    const [projectcontdata, setProjectCountData] = useState([]);
    const [toggleCompany, setToggleCompany] = useState("null");
    const [project, setProject] = useState("null");
    const handleClose = () => {

        setShow(false);

    };
    // const navigate = useNavigate();

    const [selectedLetter, setSelectedLetter] = useState(null);

    const handleRowClick = (letter) => {
        // console.log('letter', letter)
        setSelectedLetter(letter); // Store selected letter in state
        // navigate(`/admin/letterTracking`, { state: { letter } });
        // Pass state while navigating
    };


    useEffect(() => {
        getLettertatdetails()
        // console.log(toggle, 'toggle', toggle === "toogle1", lettertatdata)
        // console.log('useEffect')
    }, [toggle, project])



    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const getLettertatdetails = async (selectedToggle) => {
        try {
            const res = await axios.get(
                `${BASE_URL}/correspondence/letter_tat_alert_details/${project}/`
            );


            setLettertatData(res.data);
        } catch (err) {
            console.error(err); // Handle error if needed
        }
    };

    const [filterData, setFilterData] = useState([]);

    const applyFilters = () => {
        let filteredData = lettertatdata;
        // console.log('aaa')
        if (searchQuery !== "") {
            if (toggle === "toogle1") {
                filteredData = filteredData.filter(
                    (employee) => lettertatdata?.about_to_due?.letter_type.toLowerCase() === searchQuery.toLowerCase()
                );
            } else {
                filteredData = filteredData.filter(
                    (employee) => lettertatdata?.letter_due?.letter_type.toLowerCase() === searchQuery.toLowerCase()
                );
            }

        }


        setFilterData(filteredData);
    };

    useEffect(() => {
        console.log("useffect data")
        applyFilters()

    }, [searchQuery, lettertatdata, project])


    const handleToggleChange = (e) => {
        // console.log(e.target.value)
        setToggle(e.target.value); // Get the value of the clicked radio button
    };
    // console.log(toggle, 'toggle', toggle === "toogle1", lettertatdata)
    const [groupedData, setGroupedData] = useState({});
    const [groupedDataletterdue, setGroupedDataletterdue] = useState({});
    // useEffect(() => {
    //   console.log('groupdatas');

    //   if (lettertatdata?.about_to_due?.length > 0) {
    //     console.log('group start--------------');
    //     const grouped = {};

    //     lettertatdata.about_to_due.forEach((category) => {
    //       category.letters.forEach((letter) => {
    //         const projectName = letter.project_short_name;

    //         if (!grouped[projectName]) {
    //           grouped[projectName] = {};
    //         }

    //         const letterNum = letter.letter_num;

    //         if (!grouped[projectName][letterNum]) {
    //           grouped[projectName][letterNum] = { ...letter, count: 1 };
    //         } else {
    //           grouped[projectName][letterNum].count += 1;
    //         }
    //       });
    //     });

    //     // Convert nested object to array format
    //     const finalGrouped = Object.keys(grouped).reduce((acc, project) => {
    //       acc[project] = Object.values(grouped[project]);
    //       return acc;
    //     }, {});

    //     console.log('final', finalGrouped);
    //     setGroupedData(finalGrouped);
    //     console.log('group end--------------');
    //   }
    // }, [lettertatdata]);

    useEffect(() => {
        if (lettertatdata) {
            console.log(lettertatdata, 'lettertatadata')
            const processData = (data) => {
                const grouped = {};

                data.forEach((category) => {
                    category.letters.forEach((letter) => {
                        const { project_short_name, site_prcode, lettertype } = letter;

                        // Initialize project if not exists
                        if (!grouped[site_prcode]) {
                            grouped[site_prcode] = {
                                site_prcode,
                                project_short_name,
                                project_letters: {}
                            };
                        }

                        // Initialize letter type if not exists
                        if (!grouped[site_prcode].project_letters[lettertype]) {
                            grouped[site_prcode].project_letters[lettertype] = {
                                letter_type: lettertype,
                                letter_count: 0,
                                letters: []
                            };
                        }

                        // Add letter to respective letter type
                        grouped[site_prcode].project_letters[lettertype].letters.push(letter);
                        grouped[site_prcode].project_letters[lettertype].letter_count += 1;
                    });
                });

                // Convert to structured array format
                return Object.values(grouped).map((project) => ({
                    ...project,
                    project_letters: Object.values(project.project_letters) // Convert letter types to array
                }));
            };

            // Process 'about_to_due' category
            if (lettertatdata) {
                // Initialize empty arrays for both categories
                const aboutToDue = lettertatdata?.about_to_due?.length > 0 ? processData(lettertatdata.about_to_due) : [];
                const letterDue = lettertatdata?.letter_due?.length > 0 ? processData(lettertatdata.letter_due) : [];

                // Set the grouped data state
                setGroupedData({ about_to_due: aboutToDue, letter_due: letterDue });
            } else {
                // If 'lettertatdata' is undefined or null, set both categories to empty arrays
                setGroupedData({ about_to_due: [], letter_due: [] });
            }

            console.log('groupedData:after project', groupedData);
        }
    }, [lettertatdata, project]);



    const handleShow = () => {
        setShow(true);

    };
    return (
        <>
            <button
                title="Letter Tat"
                className="upload-svg equal-hieg"
                onClick={handleShow}
            >
                Letter Tat
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="model-width80vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Letter Tat Details
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="flex-row justify-between">
                        <div className="leave-duration-tabs">
                            <label htmlFor="toggle1" className="leave-tab">About to Due</label>
                            <input
                                type="radio"
                                id="toggle1"
                                name="leave-type"
                                value="toogle1"
                                defaultChecked
                                onClick={handleToggleChange}
                            />

                            <label htmlFor="toggle2" className="leave-tab">Letter Due
                                {/* <span className="leave-balance-duration">
                  :{" "}{projectcontdata?.lead_count}
                </span> */}
                            </label>
                            <input
                                type="radio"
                                id="toggle2"
                                name="leave-type"
                                value="toogle2"
                                onClick={handleToggleChange}
                            />


                            <span className="leave-tab-glider2" style={{ left: toggle === "toogle1" ? "-35%" : "-110%" }}></span>
                        </div>

                        <div className="flex-row">
                            {/* <div className="table-searchh">
                <div>
                  <SearchSmall />
                </div>
                <div>
                  <input
                    placeholder=""
                    className="navbar-inputt font-weight400 font-size-text"
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />
                </div>
              </div> */}

                            <div className='letter-del' style={{ margin: "10px" }}>
                                <Projects value="id" toggleProject={project} setToggleProject={setProject} subcompany={toggleCompany} />
                            </div>
                        </div>
                    </div>

                    <div className="table-container">
                        <table className="custom-table">
                            <thead className="heading">
                                <tr className="custom-table-head-tr global-table-tr">
                                    <th className="table-heading-text">Sno.</th>
                                    <th className="table-heading-text">Project Name</th>
                                    <th className="table-heading-text">Letter Type</th>
                                    <th className="table-heading-text">Letter Count</th>
                                    <th className="table-heading-text">Letter Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                {toggle === "toogle1" &&
                                    groupedData?.about_to_due?.map((project, index) => (
                                        <React.Fragment key={project.site_prcode}>
                                            {/* Project Row */}
                                            <tr className="project-header" style={{ borderTop: '1px solid black' }}>
                                                <td className="table-bodyy" style={{ fontSize: "12px" }}>{index + 1}</td>
                                                <td className="table-bodyy" >
                                                    <strong className='tat-table'>{project.project_short_name} ({project.site_prcode})</strong>
                                                </td>
                                            </tr>

                                            {/* Loop through letter types */}
                                            {project.project_letters?.map((letterGroup) => (
                                                <React.Fragment key={letterGroup.letter_type}>
                                                    {/* Letter Type Row */}
                                                    <tr className="letter-type-header" >
                                                        <td className="table-bodyy"></td>
                                                        <td className="table-bodyy"></td>
                                                        <td className="table-bodyy" >
                                                            <strong className='tat-table'>{letterGroup.letter_type}</strong>
                                                        </td>
                                                        <td className="table-bodyy">
                                                            <strong className='tat-table'>{letterGroup.letter_count}</strong>
                                                        </td>
                                                        <td className="table-bodyy">
                                                            {letterGroup.letters?.map((letter, letterIndex) => (
                                                                <React.Fragment key={letter.id}>
                                                                    {/* Letter Details Row */}
                                                                    <tr className="custom-table-head-td global-table-td">

                                                                        <td className="table-bodyy">
                                                                            <table className="nested-table">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th>Letter Number</th>
                                                                                        <th>Letter Date</th>
                                                                                        <th>Assigned TAT Days</th>
                                                                                        <th>Elapsed Days</th>
                                                                                        <th>Exceeded By</th>
                                                                                        <th>Alert</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr style={{ cursor: "pointer" }}>
                                                                                        <td onClick={() => handleRowClick(letter.letter_num)}>
                                                                                            {letter.letter_num}
                                                                                        </td>
                                                                                        <td>{letter.letter_date}</td>
                                                                                        <td>{letter.assigned_tat_days}</td>
                                                                                        <td>{letter.elapsed_days}</td>
                                                                                        <td className={parseFloat(letter.exceeded_by) > 0 ? "error-alert" : ""}>
                                                                                            {letter.exceeded_by}
                                                                                        </td>
                                                                                        <td>{letter.alert}</td>
                                                                                    </tr>

                                                                                    {/* Show sub-letter types if they exist */}
                                                                                    {letter.sub_letter_types?.map((subLetter, subIndex) => (
                                                                                        <tr key={subIndex} className="sub-letter-row">
                                                                                            <td colSpan="2">
                                                                                                <strong>Sub Letter Type:</strong> {subLetter.lettertype}
                                                                                            </td>
                                                                                            <td>{subLetter.letter_num}</td>
                                                                                            <td>{subLetter.letter_date}</td>
                                                                                            <td>{subLetter.assigned_tat_days}</td>
                                                                                            <td>{subLetter.elapsed_days}</td>
                                                                                            <td className={parseFloat(subLetter.exceeded_by) > 0 ? "error-alert" : ""}>
                                                                                                {subLetter.exceeded_by}
                                                                                            </td>
                                                                                            <td>{subLetter.alert}</td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </td>
                                                                    </tr>
                                                                </React.Fragment>
                                                            ))}
                                                        </td>
                                                    </tr>

                                                    {/* Loop through letters under this letter type */}

                                                </React.Fragment>
                                            ))}
                                        </React.Fragment>
                                    ))}

                                {toggle === "toogle2" &&


                                    groupedDataletterdue?.letter_due?.map((project, index) => (
                                        <React.Fragment key={project.site_prcode}>
                                            {/* Project Row */}
                                            <tr className="project-header" style={{ borderTop: '1px solid black' }}>
                                                <td className="table-bodyy" style={{ fontSize: "12px" }}>{index + 1}</td>
                                                <td className="table-bodyy" >
                                                    <strong className='tat-table'>{project.project_short_name} ({project.site_prcode})</strong>
                                                </td>
                                            </tr>

                                            {/* Loop through letter types */}
                                            {project.project_letters?.map((letterGroup) => (
                                                <React.Fragment key={letterGroup.letter_type}>
                                                    {/* Letter Type Row */}
                                                    <tr className="letter-type-header" >
                                                        <td className="table-bodyy"></td>
                                                        <td className="table-bodyy"></td>
                                                        <td className="table-bodyy" >
                                                            <strong className='tat-table'>{letterGroup.letter_type}</strong>
                                                        </td>
                                                        <td className="table-bodyy">
                                                            <strong className='tat-table'>{letterGroup.letter_count}</strong>
                                                        </td>
                                                        <td className="table-bodyy">
                                                            {letterGroup.letters?.map((letter, letterIndex) => (
                                                                <React.Fragment key={letter.id}>
                                                                    {/* Letter Details Row */}
                                                                    <tr className="custom-table-head-td global-table-td">

                                                                        <td className="table-bodyy">
                                                                            <table className="nested-table">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th>Letter Number</th>
                                                                                        <th>Letter Date</th>
                                                                                        <th>Assigned TAT Days</th>
                                                                                        <th>Elapsed Days</th>
                                                                                        <th>Exceeded By</th>
                                                                                        <th>Alert</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr style={{ cursor: "pointer" }}>
                                                                                        <td onClick={() => handleRowClick(letter.letter_num)}>
                                                                                            {letter.letter_num}
                                                                                        </td>
                                                                                        <td>{letter.letter_date}</td>
                                                                                        <td>{letter.assigned_tat_days}</td>
                                                                                        <td>{letter.elapsed_days}</td>
                                                                                        <td className={parseFloat(letter.exceeded_by) > 0 ? "error-alert" : ""}>
                                                                                            {letter.exceeded_by}
                                                                                        </td>
                                                                                        <td>{letter.alert}</td>
                                                                                    </tr>

                                                                                    {/* Show sub-letter types if they exist */}
                                                                                    {letter.sub_letter_types?.map((subLetter, subIndex) => (
                                                                                        <tr key={subIndex} className="sub-letter-row">
                                                                                            <td colSpan="2">
                                                                                                <strong>Sub Letter Type:</strong> {subLetter.lettertype}
                                                                                            </td>
                                                                                            <td>{subLetter.letter_num}</td>
                                                                                            <td>{subLetter.letter_date}</td>
                                                                                            <td>{subLetter.assigned_tat_days}</td>
                                                                                            <td>{subLetter.elapsed_days}</td>
                                                                                            <td className={parseFloat(subLetter.exceeded_by) > 0 ? "error-alert" : ""}>
                                                                                                {subLetter.exceeded_by}
                                                                                            </td>
                                                                                            <td>{subLetter.alert}</td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </td>
                                                                    </tr>
                                                                </React.Fragment>
                                                            ))}
                                                        </td>
                                                    </tr>

                                                    {/* Loop through letters under this letter type */}

                                                </React.Fragment>
                                            ))}
                                        </React.Fragment>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
            </Modal>
        </>


    );
};


const LetterTracking = () => {
    const tableRef = useRef(null);
    const [toggleCompany, setToggleCompany] = useState("null");

    const { PERMISSION_AUTHORITY, projectID } = usePermission();
    const siteRole = sessionStorage.getItem("role");

    const [project, setProject] = useState("null");

    const [workperformedby, setWorkperformedby] = useState("null");

    const [lettertype, setLetterType] = useState("null");

    const role = sessionStorage.getItem('role');

    const [letterData, setLetterData] = useState({});


    const [projectList, setProjectList] = useState([]);
    const [projectbyID, setProjectByID] = useState([]);

    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [statusExchnage, SetStatusexchange] = useState('');
    const [selectedNo, setNo] = useState("");
    const [selectedFromDate, setFromDate] = useState(null);
    const [selectedToDate, setToDate] = useState(null);
    const [selectedLetterStatus, setLetterStatus] = useState('null');
    const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);

    const [trackRecordList, setTrackRecordList] = useState([]);


    const [buffer, setBuffering] = useState(true); //buffering logic
    const [animation1, setAnimation1] = useState(true);

    const getProjectById = async () => {
        setBuffering(true);
        try {
            const project = await axios.get(`${BASE_URL}/project_details/projectbyid/${projectID}/`);
            setProjectByID(project.data)
        } catch (error) {

        }
    }

    useEffect(() => {
        getProjects();
    }, []);



    const getProjects = async () => {
        // setBuffering(true); //buffering logic // Start Buffering
        try {
            // const sub = await axios.get(`${BASE_URL}/project_details/subcompany/`);
            // setSiteSubCompanyList(sub.data);
            // const pro = await axios.get(`${BASE_URL}/project_details/projectfilterbysubcompany/${toggleCompany}/`);
            const pro = await axios.get(`${BASE_URL}/project_details/project/`
            );
            const sortedList = sortProjects(pro.data, "site_prcode");
            setProjectList(sortedList);

            // const res = await axios.get(`${BASE_URL}/project_details/letterrecord/`);
            // setTrackRecordList(res.data);


        } catch (err) {
            handleErrorToast(err);
        } finally {
            // setBuffering(false);// End Buffering
        }
    };

    console.log(projectList)
    const [pendencys, setPendencys] = useState({});
    const [pendingLetters, setPendingLetters] = useState(0);
    const getLetters = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(`${BASE_URL}/correspondence/letterrecordtable/${currentPage}/${itemsPerPage}/${selectedLetterStatus}/${selectedFromDate}/${selectedToDate}/${selectedNo ? selectedNo : 'null'}/${project}/${workperformedby}/${lettertype}/null/null/null/null/`);
            setPendingLetters(res.data.count);

            setPendencys(res.data.letter_type_counts);
            setTrackRecordList(res.data.results);
            // setBuffering(false);
        } catch (error) {
            handleErrorToast(error);
        } finally {
            setAnimation1(false)
            setTimeout(() => {
                setBuffering(false);

            }, 1000)
            // End Buffering


            // setTimeout()

        }
    }
    // useEffect(() => {
    //   getProjects();

    // }, [toggleCompany])

    useEffect(() => {
        getLetters();

    }, [selectedLetterStatus, selectedFromDate, selectedToDate, project, workperformedby, lettertype, toggleCompany])


    useEffect(() => {
        applyFilters();
    }, [selectedNo, trackRecordList, statusExchnage]);

    const applyFilters = () => {
        let filteredData = trackRecordList;

        if (selectedNo !== "") {
            const lowercaseSelectedName = selectedNo.toLowerCase();



            filteredData = filteredData.filter(employee => {
                if (!employee || !employee.letter_num) {
                    console.log("Skipping undefined or missing letter_num for employee:", employee);
                    return false; // Skip entries with undefined or missing letter_num
                }

                const lid = employee?.letter_num.toString()?.toLowerCase().includes(lowercaseSelectedName) || employee?.subject?.toLowerCase()?.includes(lowercaseSelectedName) || employee?.remarks?.toLowerCase()?.includes(lowercaseSelectedName);
                return lid;
            });



        }
        if (statusExchnage !== "") {
            console.log(statusExchnage)
            const lowercaseSelectedName = statusExchnage?.toLowerCase();
            filteredData = filteredData.filter(exchange => {
                const letterExhange = exchange?.letterExchange?.toLowerCase()?.includes(lowercaseSelectedName);

                return letterExhange;
            });
        }


        setFilteredData(filteredData);
    };

    const location = useLocation();
    const letter = location.state?.letter;
    console.log('letter', location.state)

    const rowRefs = useRef([]);

    useEffect(() => {
        if (letter && filteredData.length > 0) {
            const matchingIndex = filteredData.findIndex(item => item.project === letter.project);

            if (matchingIndex !== -1 && rowRefs.current[matchingIndex]) {
                rowRefs.current[matchingIndex].scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }, [letter, filteredData]);
    const itemsPerPage = 50;
    const [currentPage, setCurrentPage] = useState(1);
    const [pageData, setPageData] = useState([]);
    const [totalPages, setTotalPages] = useState("");


    useEffect(() => {
        const newTotalPages = Math.ceil(pendingLetters / itemsPerPage);



        // Optional: reset only if filteredData shrinks AND page is now invalid
        if (currentPage > newTotalPages && newTotalPages > 0) {
            setTotalPages(newTotalPages);
        }
    }, [filteredData]);



    const handlePageChange = (page) => {
        if (page < 1 || page > totalPages) return;
        setCurrentPage(page);
        // Scroll to top of table when page changes
        if (tableRef && tableRef.current) {
            tableRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    const renderPaginationButtons = () => {
        const buttons = [];

        // Always show first page
        buttons.push(
            <button
                key="first"
                className={`pagination-button ${currentPage === 1 ? 'active' : ''}`}
                onClick={() => handlePageChange(1)}
            >
                1
            </button>
        );


        if (totalPages > 7) {

            let startPage = Math.max(2, currentPage - 1);
            let endPage = Math.min(totalPages - 1, currentPage + 1);


            if (currentPage <= 3) {
                // Near start, show 2,3,4
                startPage = 2;
                endPage = 4;
            } else if (currentPage >= totalPages - 2) {
                // Near end, show last 3 pages before the final page
                startPage = totalPages - 3;
                endPage = totalPages - 1;
            }

            // Show ellipsis before middle range if needed
            if (startPage > 2) {
                buttons.push(<span key="ellipsis1" className="pagination-ellipsis">...</span>);
            }

            // Add middle range
            for (let i = startPage; i <= endPage; i++) {
                buttons.push(
                    <button
                        key={i}
                        className={`pagination-button ${currentPage === i ? 'active' : ''}`}
                        onClick={() => handlePageChange(i)}
                    >
                        {i}
                    </button>
                );
            }

            // Show ellipsis after middle range if needed
            if (endPage < totalPages - 1) {
                buttons.push(<span key="ellipsis2" className="pagination-ellipsis">...</span>);
            }

            // Always show last page
            buttons.push(
                <button
                    key="last"
                    className={`pagination-button ${currentPage === totalPages ? 'active' : ''}`}
                    onClick={() => handlePageChange(totalPages)}
                >
                    {totalPages}
                </button>
            );
        } else {
            // Less than 7 pages, show all page buttons
            for (let i = 2; i <= totalPages; i++) {
                buttons.push(
                    <button
                        key={i}
                        className={`pagination-button ${currentPage === i ? 'active' : ''}`}
                        onClick={() => handlePageChange(i)}
                    >
                        {i}
                    </button>
                );
            }
        }

        return buttons;
    };

    const handleClearAllFilter = () => {
        setProject("null");
        setLetterType("null");
        setNo("");
        SetStatusexchange("");
        setWorkperformedby("null");
        setLetterStatus("null");
        setFromDate(null);
        setToDate(null);
    };


    const handleStatusCardClick = (e) => setLetterType(e);

    const [expanded, setExpanded] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const [showAdvanced, SetShowAdvanced] = useState(false);
    const [toggleAe, setToggleAe] = useState("null");
    return (
        <>

            <Dashboardnavbar name={"Letter Tracking"} url="Letter Tracking" />
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <div className='content-tabs'>

                <div className="attendance-history-cont">

                    <>
                        <div>
                            <div className="attendance-heading  font-weight500    font-size-heading"> </div>
                            <div className="attendance-subcontainer" >
                                <div className="field-cont" style={{ width: "70vw" }}>




                                    {siteRole === "SiteManagement" ? "" :

                                        <Projects value="id" toggleProject={project} setToggleProject={setProject} subcompany={toggleCompany} />

                                    }

                                    <LetterType setLetterType={setLetterType} lettertype={lettertype} />
                                    <div title='Search Filter' className="field-cont-div">
                                        <SearchSmall />
                                        <input className="attendance-input-field width-15vw"
                                            placeholder='Letter no./Subject/remarks'
                                            type="text"
                                            value={selectedNo}
                                            onChange={(e) => setNo(e.target.value)} />

                                        <hr className="field-cont-hr" />
                                    </div>

                                    <div title="Exchange Type" className="field-cont-div">
                                        <ExchangeTypee />
                                        <select
                                            onChange={(e) => SetStatusexchange(e.target.value)}
                                            value={statusExchnage}
                                            className="attendance-input-field width-10vw   date-field"
                                        >
                                            <option value="">Exchange Type</option>
                                            <option value="receive">Recieve</option>
                                            <option value="send">Send</option>

                                        </select>

                                        <hr className="field-cont-hr" />
                                    </div>

                                    <div title="Letter For" className="field-cont-div">
                                        <CircularGrid />
                                        <select
                                            onChange={(e) => setWorkperformedby(e.target.value)}
                                            value={workperformedby}
                                            className="attendance-input-field width-10vw   date-field"
                                        // className="dropdown font-size-subheading  "
                                        >
                                            <option className='' value="null">Letter For</option>
                                            <option value="contractor">Contractor</option>
                                            <option value="consultant">Consultant</option>

                                        </select>

                                        <hr className="field-cont-hr" />
                                    </div>

                                    <div title="Status Filter" className="field-cont-div">
                                        <Status />
                                        <select
                                            id="status"
                                            name="status"
                                            placeholder="Status"
                                            value={selectedLetterStatus}
                                            onChange={(e) => setLetterStatus(e.target.value)}
                                            className={`attendance-input-field width-10vw `}
                                        >
                                            <option value="null">Status</option>

                                            <option value="pending">Pending</option>

                                            <option value="in-progress">InProgress</option>
                                            <option value="partially-close">Partially Close</option>

                                            <option value="close">Close</option>
                                        </select>
                                        <hr className="field-cont-hr" />
                                    </div>

                                    <div title="Date Range Filter" className="field-cont-div ">
                                        <DateRangePicker startDate={selectedFromDate} endDate={selectedToDate} placeHolder1="From Date" placeHolder2="To Date" onChange={(start, end) => {
                                            setFromDate(start);
                                            setToDate(end);
                                        }} />
                                        <hr className="field-cont-hr" />
                                    </div>

                                    <div style={{ color: '#2576bc', cursor: 'pointer' }} onClick={handleClearAllFilter}>Clear All</div>

                                </div>
                                <div className="btn-cont">
                                    <DownloadTableExcel
                                        filename="Letters-data"
                                        sheet="projectDetails"
                                        currentTableRef={tableRef.current}
                                    >
                                        <button className="model-button font-weight500   model-button-print">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="download" fill="#fff">
                                                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                                    <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                                                </g>
                                            </svg>
                                        </button>
                                    </DownloadTableExcel>
                                    {siteRole === "BD" ? "" :
                                        <>
                                            {/* <AddTrackRecordDetails getProjects={getLetters} projectList={projectList} projectId={project} title={"Letters"} /> */}
                                            <AddLetterLinked getProjects={getLetters} projectList={projectList} projectId={project} title={"Letters"} />

                                            {/* <UploadLetterBulk getLetters={getLetters} site_prcode={projectbyID.site_prcode} /> */}

                                        </>
                                    }

                                    {/* <DashboardLetterTatTypeModel project={project} /> */}

                                </div>
                            </div>
                        </div>
                        {/* <div className='filter-showing'>
                            
                            <div></div>
                            <div>Showing {trackRecordList.length} of {trackRecordList.length} </div>
                        </div> */}
                        <div className='filter-showing'>
                            <div style={{ fontsSize: '18px', fontWeight: 500 }}>Letter Pendency</div>


                            {isOverflowing && (
                                <div className="toggle-button-status-card" style={{ marginLeft: '20px' }} onClick={() => setExpanded(!expanded)}>
                                    {expanded ? "▲ Collapse" : "▼ Expand"}
                                </div>
                            )}
                            <div style={{ fontSize: '16px', fontWeight: 400, marginLeft: 'auto', display: 'flex', gap: '20px' }} >
                                {siteRole === "Admin" && <div className="toggle-button-status-card" style={{ marginLeft: '20px' }} > <button onClick={() => SetShowAdvanced(!showAdvanced)} style={{ color: '#2576bc' }}>
                                    {!showAdvanced ? "▲ Show Advanced Stats" : "▼ Hide Advanced Stats"}
                                </button></div>}
                                Showing
                                {Math.min((currentPage - 1) * itemsPerPage + 1, pendingLetters)} - {Math.min(currentPage * itemsPerPage, pendingLetters)} of {pendingLetters}
                                records
                            </div>

                        </div>
                        <StatusBar isOverflowing={isOverflowing} expanded={expanded} setIsOverflowing={setIsOverflowing} onClick={handleStatusCardClick} loading={buffer} data={[{ title: 'All Letters', label: pendingLetters, value: 'null' }, { title: 'BBS', label: pendencys?.BBS, value: 'BBS' }, { title: 'BILLING', label: pendencys?.BILLING, value: 'billing' }, { title: 'Billing', label: pendencys?.Billing, value: 'billing' }, { title: 'COS', label: pendencys?.COS, value: 'cos' }, { title: 'DESIGN AND DRAWING', label: pendencys?.DESIGN_AND_DRAWING, value: 'Design & Drawing' }, { title: 'DRAIN', label: pendencys?.DRAIN, value: 'Drain' }, { title: 'Design', label: pendencys?.Design, value: 'Design' }, { title: 'EOT', label: pendencys?.EOT, value: 'eot' }, { title: 'HYDROLOGY', label: pendencys?.HYDROLOGY, value: 'Hydrology' }, { title: 'Informative', label: pendencys?.Informative, value: 'informative' }, { title: 'Milestone', label: pendencys?.Milestone, value: 'Milestone' }, { title: 'NCR', label: pendencys?.NCR, value: 'ncr' }, { title: 'NOC', label: pendencys?.NOC, value: 'noc' }, { title: 'Others', label: pendencys?.Others, value: 'other' }, { title: 'P AND P', label: pendencys?.P_AND_P, value: 'P&P' }, { title: 'QAP', label: pendencys?.QAP, value: 'QAP' }, { title: 'Q AND ME', label: pendencys?.Q_AND_ME, value: 'Q & ME' }, { title: 'Query', label: pendencys?.Query, value: 'query' }, { title: 'ROAD SAFETY', label: pendencys?.ROAD_SAFETY, value: 'Road Safety' }, { title: 'STRUCTURE', label: pendencys?.STRUCTURE, value: 'Structure' }, { title: 'SURVEY', label: pendencys?.SURVEY, value: 'Survey' }, { title: 'Show Cause', label: pendencys?.ShowCause, value: 'show-cause' }, { title: 'Site Progress', label: pendencys?.SiteProgress, value: 'SiteProgress' }, { title: 'WORK PLAN', label: pendencys?.WORK_PLAN, value: 'Work Plan' }]} />
                        {showAdvanced &&
                            <AdvancedStats showAdvanced={showAdvanced} SetShowAdvanced={SetShowAdvanced} toggleAe={toggleAe} />
                        }

                        <div className="table-css-white-background ">


                            <div className='table-box  scroll-container-table'>
                                <div >

                                    <table ref={tableRef} className="table-css">
                                        <thead className='table-heading'>
                                            <tr className='custom-table-head-tr'>
                                                <th className='table-heading-text text-left-sr'>S.no.</th>
                                                {!projectID ? <th className='table-heading-text'>Project</th> : ""}
                                                <th className='table-heading-text'>Letter No.</th>
                                                <th className='table-heading-text'>Subject</th>
                                                <th className='table-heading-text text-center'>Letter Details</th>
                                                <th className='table-heading-text text-center'>Dates</th>
                                                {siteRole === "BD" ? "" :
                                                    <>
                                                        <th className='table-heading-text'>Action</th>
                                                    </>
                                                }
                                            </tr>
                                        </thead>
                                        {buffer ? (

                                            <div>
                                                <SkeletonLoader animationfirst={animation1} />
                                            </div>
                                            //  <div className={`${p_id ? "spinner-smalll" : "spinner-bgdatil"}`}></div>

                                        ) : error ? (
                                            <p>Error fetching data: {error.message}</p>
                                        ) :
                                            <tbody>
                                                {/* {filteredData.sort((a,b) => b.date - a.date).map((i, index) => ( */}
                                                {Array.isArray(filteredData) &&
                                                    filteredData
                                                        .sort((a, b) => new Date(b.letter_date) - new Date(a.letter_date))
                                                        .map((i, index) => (
                                                            <React.Fragment key={index}>
                                                                <tr className="custom-table-head-td " ref={(el) => (rowRefs.current[index] = el)} >

                                                                    <td className='table-body text-left-sr'>{(currentPage - 1) * itemsPerPage + index + 1}.</td>



                                                                    {!projectID ? <td className='table-body'><div style={{ width: "120px", whiteSpace: "normal" }}>{i?.project_pr_code ? `${i?.project_pr_code}-` : ""}{i.project_short_name}</div></td> : ""}
                                                                    <td className="table-body form-text-transformation-uppercase">
                                                                        <div
                                                                            style={{
                                                                                width: "120px",
                                                                                wordBreak: "break-word", // Ensures words break at the container width
                                                                                whiteSpace: "normal",    // Allows wrapping to the next line
                                                                            }}
                                                                        >
                                                                            {i.letter_num}
                                                                        </div>
                                                                    </td>
                                                                    <td className='table-body'><div style={{ width: "100px", whiteSpace: "normal" }}>{i.subject ? i.subject : <p className=''>-</p>}</div></td>


                                                                    <td className="table-body width-20vw">
                                                                        <div className="flex-column align-items-center">

                                                                            <table>
                                                                                <tbody className="table-body">
                                                                                    <tr>
                                                                                        <td className="padding-bottom-5px text-start">Exchange Type</td>
                                                                                        <td style={{ padding: "0px 10px" }}>:</td>
                                                                                        <td className="text-start">
                                                                                            <div style={{ width: "100px", whiteSpace: "normal" }}>
                                                                                                {i.letterExchange
                                                                                                    ? i.letterExchange
                                                                                                    : "-"}
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="padding-bottom-5px text-start">Letter Type</td>
                                                                                        <td style={{ padding: "0px 10px" }}>:</td>
                                                                                        <td className="text-start">
                                                                                            <div style={{ width: "100px", whiteSpace: "normal" }}>
                                                                                                {i.lettertype !== "other" ?
                                                                                                    i.lettertype
                                                                                                    : i.other_type_name}
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="padding-bottom-5px text-start">Letter from</td>
                                                                                        <td style={{ padding: "0px 10px" }}>:</td>
                                                                                        <td className="text-start">
                                                                                            <div style={{ width: "100px", whiteSpace: "normal" }}>
                                                                                                {i.letter_from === "null" ?
                                                                                                    '-'
                                                                                                    : i.letter_from}
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="padding-bottom-5px text-start">Letter to</td>
                                                                                        <td style={{ padding: "0px 10px" }}>:</td>
                                                                                        <td className="text-start">
                                                                                            <div style={{ width: "100px", whiteSpace: "normal" }}>
                                                                                                {i.letter_to === "null" ?
                                                                                                    '-'
                                                                                                    : i.letter_to}
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="padding-bottom-5px text-start">Reply By</td>
                                                                                        <td style={{ padding: "0px 10px" }}>:</td>
                                                                                        <td className="text-start">
                                                                                            <div style={{ width: "100px", whiteSpace: "normal" }}>
                                                                                                {i.reply_by === null ?
                                                                                                    '-'
                                                                                                    : i.reply_by}
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="padding-bottom-5px text-start">Subject</td>
                                                                                        <td style={{ padding: "0px 10px" }}>:</td>
                                                                                        <td className="text-start">
                                                                                            <div style={{ width: "100px", whiteSpace: "normal" }}>
                                                                                                {i.subject === null ?
                                                                                                    '-'
                                                                                                    : i.subject}
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="padding-bottom-5px text-start">Letter Related To</td>
                                                                                        <td style={{ padding: "0px 10px" }}>:</td>
                                                                                        <td className="text-start">
                                                                                            <div style={{ width: "100px", whiteSpace: "normal" }}>
                                                                                                {i.workperformedby_contractor ?
                                                                                                    i.workperformed_by_contractor_name
                                                                                                    : null}
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="padding-bottom-5px text-start">Status</td>
                                                                                        <td style={{ padding: "0px 10px" }}>:</td>
                                                                                        <td className="text-start">
                                                                                            <div style={{ width: "100px", whiteSpace: "normal" }}>
                                                                                                {i.status
                                                                                                    ? i.status
                                                                                                    : "-"}
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="padding-bottom-5px text-start">TAT Duration</td>
                                                                                        <td style={{ padding: "0px 10px" }}>:</td>
                                                                                        <td className="text-start">
                                                                                            <div style={{ width: "100px", whiteSpace: "normal" }}>
                                                                                                {i.tat_duration
                                                                                                    ? i.tat_duration
                                                                                                    : "-"}
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="padding-bottom-5px text-start">Due Days</td>
                                                                                        <td style={{ padding: "0px 10px" }}>:</td>
                                                                                        <td className="text-start">
                                                                                            <div style={{ width: "100px", whiteSpace: "normal" }}>

                                                                                                {i.end_date ? CalculateDaysBetweenDates(i.end_date) : "-"}

                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="padding-bottom-5px text-start">Remarks</td>
                                                                                        <td style={{ padding: "0px 10px" }}>:</td>
                                                                                        <td className="text-start">
                                                                                            <div style={{ width: "100px", whiteSpace: "normal" }}>
                                                                                                {i.remarks
                                                                                                    ? <CustomModel i={i.remarks} usedFor="nestedTable" title="Remarks" />
                                                                                                    : "-"}
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>

                                                                                        <td className="padding-bottom-5px text-start">Associated Letters</td>
                                                                                        <td style={{ padding: "0px 10px" }}>:</td>
                                                                                        <td className="text-start">
                                                                                            <div style={{ width: "100px", whiteSpace: "normal" }}>
                                                                                                {i.associated_letters.length > 0
                                                                                                    ?
                                                                                                    <AssociatedLetters usedFor="nestedTable" id={i.id} />
                                                                                                    : <p className=''>-</p>}
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="padding-bottom-5px text-start">View Letter</td>
                                                                                        <td style={{ padding: "0px 10px" }}>:</td>
                                                                                        <td className="text-start">
                                                                                            <div style={{ width: "100px", whiteSpace: "normal" }}>
                                                                                                <DocumentModel letterrecord={i.id} letterData={i.letter_tracking} title={"Documents"} getDocument={getLetters} usedFor="nestedTable" />
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </td>

                                                                    <td className="table-body width-15vw">
                                                                        <div className="flex-column align-items-center">
                                                                            <table>
                                                                                <tbody className="table-body">
                                                                                    <tr>
                                                                                        <td className="padding-bottom-5px text-start">Letter Date</td>
                                                                                        <td style={{ padding: "0px 10px" }}>:</td>
                                                                                        <td className="text-start">{i.letter_date !== null ? formattedDateLong(i.letter_date) : "-"}</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="padding-bottom-5px text-start">Letter Add</td>
                                                                                        <td style={{ padding: "0px 10px" }}>:</td>
                                                                                        <td className="text-start">{i.created_at !== null ? formattedDateLong(i.created_at) : "-"}</td>
                                                                                    </tr>
                                                                                    {/* <tr>
                                                                                        <td className="padding-bottom-5px text-start">Deadline</td>
                                                                                        <td style={{ padding: "0px 10px" }}>:</td>
                                                                                        <td className="text-start">{i.end_date !== null ? formattedDateLong(i.end_date) : "-"}</td>
                                                                                    </tr> */}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </td>




                                                                    {siteRole === "BD" ? "" :
                                                                        <>
                                                                            <td className='table-body '>
                                                                                <UpdateTrackRecordDetails
                                                                                    i={i}
                                                                                    getProjects={getLetters}
                                                                                    projectList={projectList}
                                                                                    projectId={i.project}
                                                                                    letterType={i.lettertype}
                                                                                    workperformedby={i.workperformedby}
                                                                                    associatedletters={i.associated_letters}
                                                                                    letterData={letterData}


                                                                                // associatedletters={i.associated_letters_get[0].letter_num }
                                                                                />
                                                                                {siteRole === 'Admin' ?
                                                                                    <DeleteTrackAndLetterDetails i={i} getLetterDetail={getLetters} /> : ""}


                                                                            </td>

                                                                        </>
                                                                    }
                                                                </tr>
                                                            </React.Fragment>
                                                        ))}

                                            </tbody>
                                        }
                                    </table>


                                </div>
                            </div>


                        </div>
                        {totalPages > 1 && (
                            <div className="pagination-controls">
                                <button
                                    className="pagination-nav-button"
                                    onClick={() => handlePageChange(currentPage - 1)}
                                    disabled={currentPage === 1}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <polyline points="15 18 9 12 15 6"></polyline>
                                    </svg>
                                    Prev
                                </button>

                                <div className="pagination-buttons">
                                    {renderPaginationButtons()}
                                </div>

                                <button
                                    className="pagination-nav-button"
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    disabled={currentPage === totalPages}
                                >
                                    Next
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </button>
                            </div>
                        )}

                        <div className="pagination-info">
                            Showing {Math.min((currentPage - 1) * itemsPerPage + 1, filteredData.length)} - {Math.min(currentPage * itemsPerPage, filteredData.length)} of {filteredData.length} records
                        </div>
                    </>
                </div>
            </div>
        </>
    );
}


const LetterExchangePage = ({ letterId }) => {
    const { letter_id, assigned_to } = useParams();
    const [letterData, setLetterData] = useState([]);
    const [projectList, setProjectList] = useState([]);
    const [contractor, setContractor] = useState([]);
    const [buffer, setBuffering] = useState(false);
    const [contractorName, setContractorName] = useState([]);



    const getProject = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/project_details/projectbyid/${letterData.project}/`
            );
            setProjectList(res.data);
            const contractor = await axios.get(
                `${BASE_URL}/project_details/contractorbyproject/${letterData.project}/`
            );
            setContractor(contractor.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };


    console.log(`letterData.letter_tracking`)
    console.log(letterData.letter_tracking)

    const getLettersingle = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/correspondence/getletterrecordanddoc/${letter_id}/`
            );
            setLetterData(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getLettersingle();
    }, [letter_id]);

    useEffect(() => {
        if (letterData.project) {
            getProject();
        }
    }, [letterData.project]);

    useEffect(() => {
        if (letterData.contractor) {
            const contractor_name = contractor.find(i => i.id === letterData.contractor);
            setContractorName(contractor_name || {}); // Ensure it's always an object
        }
    }, [letterData.contractor, contractor]);


    console.log("contractorName");
    console.log(contractorName);




    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <div className="dashboard-main-section" style={{ width: "100%", background: "#f4f7fe", height: "auto" }}>
                <div className="content-tabs" style={{ width: "100%" }}>
                    <div className="info-box-div-bg">

                        <div className="jd-heading-outer heading-bg-color-white">
                            <div className="jd-heading-outer-flex">
                                <h2 className="jd-heading-main font-weight600 font-size-heading">
                                    Letter Details of :"{letterData?.letter_num} " of project:"{projectList.site_prcode}-{projectList.project_short_name}"
                                </h2>
                                <div>
                                    <DocumentModel title="Letters" letterrecord={letterData.id} getDocument={getLettersingle} letterData={letterData} />
                                </div>
                            </div>
                            <div>
                                <div className="jd-heading-bottom-bold" style={{ width: "35vw", height: "2px" }}></div>
                                <div className="jd-heading-bottom-light"></div>
                            </div>
                        </div>
                        <div className="flex-row justify-between">
                            <div className="">
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text table-body">Letter Date</td>
                                    <td>:</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text table-body">
                                        {letterData.letter_date
                                            ? new Date(letterData.letter_date).toISOString().split('T')[0].split('-').reverse().join('/')
                                            : "N/A"}
                                    </th>

                                </tr>
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text table-body">Work Performed By</td>
                                    <td>:</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text table-body">{letterData.workperformedby}</th>
                                </tr>
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text table-body">Contractor Name</td>
                                    <td>:</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text table-body">{contractorName.name}</th>
                                </tr>
                            </div>
                            <div>
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text table-body">Letter Type</td>
                                    <td>:</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text table-body">{letterData.lettertype}</th>
                                </tr>
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text table-body">Subject</td>
                                    <td>:</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text table-body">{letterData.subject}</th>
                                </tr>
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text table-body">Letter Status</td>
                                    <td>:</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text table-body">{letterData.status}</th>
                                </tr>
                            </div>
                            <div>
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text table-body">Letter Remark</td>
                                    <td>:</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text table-body">{letterData.remarks}</th>
                                </tr>
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text table-body">Letter Exchange Type</td>
                                    <td>:</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text table-body">{letterData.letterExchange}</th>
                                </tr>
                                <tr>
                                    <td className="personal-detail-1 font-weight500 font-size-text table-body">Associated Letters</td>
                                    <td>:</td>
                                    <th className="personal-detail-2 font-weight500 font-size-text table-body"><AssociatedLetters id={letterData.id} LetterData={letterData.id} /></th>
                                </tr>
                            </div>
                        </div>

                    </div>
                    <div className="info-box-div-bg " style={{ marginTop: "20px" }}>
                        <div >
                            <div className="jd-heading-outer-flex ">
                                <h2 className="jd-heading-main font-weight600  font-size-heading">Authority Exchange List</h2>
                                <div className="field-cont">
                                    <AddAssignTO
                                        siteprcode={projectList.site_prcode}
                                        projectname={projectList.project_short_name}
                                        letterno={letterData.letter_num}
                                        letterId={letter_id}
                                        subject={letterData.subject}
                                        assignemail={assigned_to}
                                        getData={getLettersingle}
                                    />
                                </div>
                            </div>
                            <div>
                                <div className="jd-heading-bottom-bold"></div>
                                <div className="jd-heading-bottom-light"></div>
                            </div>
                        </div>

                        <div className="form-flex-wrap table-box paddingTop-0px  scroll-container-table child-table-scroll" >
                            <table className="table-css">
                                <thead className='table-heading'>
                                    <tr className="custom-table-head-tr">
                                        <th className="table-heading-text text-lefttt">S. No.</th>
                                        <th className="table-heading-text">Assigned Work</th>
                                        <th className="table-heading-text">Assigned By</th>
                                        <th className="table-heading-text">Assigned To</th>
                                        <th className="table-heading-text">Your Work</th>
                                        <th className="table-heading-text text-center">Add/View Documents</th>
                                        <th className="table-heading-text text-right">Work Assigned Date</th>
                                    </tr>
                                </thead>
                                {buffer ? (
                                    <div className="loading-spinner"></div>
                                ) : (
                                    <tbody>
                                        {letterData.letter_tracking?.map((i, index) => (
                                            <tr className="custom-table-head-td" key={index}>
                                                <td className="table-body text-lefttt">{index + 1}</td>
                                                <td className="table-body">{i.assiginee_remarks ? i.assiginee_remarks : "-"}</td>
                                                <td className="table-body">{i.assigned_by_name ? i.assigned_by_name : "-"}</td>
                                                <td className="table-body">{i.assigned_to_name ? i.assigned_to_name : "-"}</td>
                                                <td className="table-body">{i.remarks ? i.remarks : "-"}</td>

                                                {i.assigned_to === assigned_to ? (
                                                    <td className="table-body ">
                                                        <div className="flex-row justify-center">
                                                            <DocumentModel
                                                                letterData={letterData.letter_tracking}
                                                                letter_tracking={i?.id}
                                                                title="Document"
                                                                getDocument={getLettersingle}
                                                            />
                                                        </div>
                                                    </td>
                                                ) : (
                                                    <td className="table-body text-center">-</td>
                                                )}
                                                <td className="table-body text-right">
                                                    {new Date(i.created_at).toISOString().split('T')[0].split('-').reverse().join('/')}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                )}
                            </table>
                        </div>

                    </div>
                </div>
            </div>

            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};



export { LetterTracking, LetterExchangePage }
